import type { CatalogItem } from '@/lib/api/types.js';
import { CatalogCard } from './catalog-card.js';

interface CatalogGridProps {
  items: ReadonlyArray<CatalogItem>;
  onFavoriteToggle: (tenantReportId: string, currentValue: boolean) => void;
  pendingIds?: ReadonlySet<string>;
}

export function CatalogGrid({ items, onFavoriteToggle, pendingIds }: CatalogGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item) => (
        <CatalogCard
          key={item.tenant_report_id}
          item={item}
          onFavoriteToggle={onFavoriteToggle}
          isFavoritePending={pendingIds?.has(item.tenant_report_id) ?? false}
        />
      ))}
    </div>
  );
}
